module.exports = __webpack_public_path__ + "static/media/Team 39 - Route 39.61ede3ac.png";